<app-spinner [loading]="load"></app-spinner>
<mat-form-field appearance="fill" class="w-100">
  <mat-label>მშობელი გვერდი</mat-label>
  <input
    type="text"
    matInput
    [formControl]="searchControl"
    [matAutocomplete]="auto"
    class="form-control"
    placeholder="მოძებნე მშობელი გვერდი"
   (click)="onInputClick()"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onSelect($event.option.value)"
  >
    <mat-option [value]="{ id: 0, menutitle: '' }">ცარიელი</mat-option>
    <mat-option *ngFor="let page of filteredPages" [value]="page">
      {{ page.menutitle }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>


